@let formModel = this.formModel();
@let checkBoxFormModel = this.checkBoxFormModel();
@let loading = this.loading();
@let marginWithSuccess = this.marginWithSuccess();

<div [class.my-3]="marginWithSuccess" [class.mt-3]="!marginWithSuccess">
  <mwe-headline [headlineNodeType]="actualHeadingNodeType()">{{ 'newVoucher.wl.title' | translate }}</mwe-headline>
  <p>{{ 'newVoucher.wl.text' | translate: translate() }}</p>

  <mwe-form #form [formModel]="formModel" (formIsValid)="onFormChange($event, true)" (formIsInvalid)="onFormChange($event, false)" />

  <mwe-form #checkBoxForm [formModel]="checkBoxFormModel" (formChanged)="onCheckboxFormChange($event)" />

  <div class="row">
    <div class="col-lg-auto">
      <mwe-button
        [labelKey]="'newVoucher.wl.button'"
        [hasMinWidth]="true"
        [hasFullWidth]="true"
        [showSpinner]="loading"
        [disabled]="loading"
        (click)="onClick()"
        data-test="mwe-new-wl-voucher-code-submit"
      />
    </div>
  </div>
</div>
